import React, { useEffect, useState } from "react";
import PageHeader from "../components/PagesHeaderComponent/PageHeader";
import { Button, Card } from "react-bootstrap";
import { useNavigate } from "react-router-dom/dist";
import { Sec7, Sec8 } from "../components/Homecomponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUsers } from "@fortawesome/free-solid-svg-icons";
import PageHeaderWithRoutes from "../components/PagesHeaderComponent/PageHeaderWithRoute";
import DocIcon from "../../assets/images/icons/document_icon.png"
import WebinarIcon from "../../assets/images/icons/webinar_icon2.png"
import VideoIcon from "../../assets/images/icons/video_icon.png"
import FaqIcon from "../../assets/images/icons/faq_icon.png"
import DownloadIcon from "../../assets/images/icons/download.png"
import ReactPlayer from "react-player";
import { Button as AntButton, Collapse, Dropdown, Input, Menu, Pagination } from "antd";
import { Col, Container, Row } from "react-bootstrap";
import InnerHeading from "../components/InnerHeading/InnerHeading";
import CoreHttpHandler from "../../http/services/CoreHttpHandler";
import { ToastAlertSuccess } from "../../reauseble";
import LinearProgress from '@mui/material/LinearProgress';
import { Box, Tooltip } from "@mui/material";
import CustomTextLimit from "../../assets/global-components/TextLimit";


const { Panel } = Collapse;

const Faqs = () => {

	const [faqs, setFaqs] = useState([]);
	const [allFaqs, setAllFaqs] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [currentPage, setCurrentPage] = useState(1);
	const [activeKey, setActiveKey] = useState([]);
	const [searchTitle, setSearchTitle] = useState("");
	const [selectedOrder, setSelectedOrder] = useState("DESC");
	const pageSize = 6;

	const getFaqs = () => {
		setIsLoading(true)
		CoreHttpHandler.request(
			"shareholder_rights",
			"fetchFaqs",
			{
				"type": "shareholder",
				"status": "true",
				"limit": 10000,
				"page": 1
			},
			(res) => {
				setAllFaqs(res.data.data.faqs.faqs)
				setIsLoading(false)
			},
			(err) => {
				setIsLoading(false)
			}
		);
	};

	const filterFaqs = () => {
		let filtered = allFaqs;

		if (searchTitle) {
			filtered = filtered.filter(faq =>
				faq.question?.toLowerCase().includes(searchTitle.toLowerCase())
			);
		}

		const sorted = [...filtered].sort((a, b) =>
			selectedOrder === "ASC"
				? a.id - b.id
				: b.id - a.id
		);

		setFaqs(sorted);
		setCurrentPage(1);
	};

	const handleOrderMenuClick = (e) => {
		setSelectedOrder(e.key);
	};

	const clearSearch = () => {
		setSearchTitle("");
		setSelectedOrder("DESC");
		setFaqs(allFaqs);
		setCurrentPage(1);
	};

	const orderMenu = (
		<Menu onClick={handleOrderMenuClick}>
			<Menu.Item key={"ASC"}>ASC</Menu.Item>
			<Menu.Item key={"DESC"}>DESC</Menu.Item>
		</Menu>
	);

	const paginatedFaqs = faqs.slice(
		(currentPage - 1) * pageSize,
		currentPage * pageSize
	);




	let headerData = [{
		name: " Your Rights",
		route: "/ShareHoldersRights/Documents",
		imgSrc: DocIcon
	}
		, {
		name: "Videos",
		route: "/ShareHoldersRights/Videos",
		imgSrc: VideoIcon
	}
		, {
		name: "Webinars",
		route: "/ShareHoldersRights/Webinars",
		imgSrc: WebinarIcon
	}
		, {
		name: "FAQs",
		route: "/ShareHoldersRights/Faqs",
		imgSrc: FaqIcon
	}
	]

	useEffect(() => {
		getFaqs();
	}, [])

	useEffect(() => {
		filterFaqs();
	}, [allFaqs])
	return (
		<>
			{/* <PageHeader heading="Webinars and Events" /> */}
			<PageHeaderWithRoutes tabs={headerData} heading="Shareholder Rights" desc="Stay informed about your rights as a shareholder and exercise your rights in the best interest of your role as a responsible shareholder!" />

			<div className="content_wrap">
				<section className='sec faq_pg_sec1'>
					<div className='container'>
						<InnerHeading heading="FAQs" text="Find quick and up to the point answers to commonly asked questions regarding shareholder rights and related matters." />

						<Container style={{ animation: "fadeInUp 0.5s ease both" }}>
							<Row className="d-flex align-items-center justify-content-center mb-4">
								<Col lg={5} md={5} xs={12} style={{ marginBottom: "10px" }}>
									<Input
										value={searchTitle}
										style={{ width: "100%", borderRadius: "20px", padding: "8px 15px", transition: "all 0.3s ease", border: "1px solid #d9d9d9" }}
										onFocus={(e) => e.target.style.boxShadow = "0 0 0 3px rgba(7,88,143,0.1)"}
										onBlur={(e) => e.target.style.boxShadow = "none"}
										onChange={(e) => setSearchTitle(e.target.value)}
										placeholder="Search by Question"
									/>
								</Col>
								<Col lg={2} md={2} xs={4} style={{ marginBottom: "10px" }}>
									<Dropdown overlay={orderMenu} trigger={['click']}>
										<AntButton
											style={{ width: "100%", borderRadius: "20px", padding: "0 15px", height: "36px", transition: "all 0.3s ease" }}
											onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#07588f"; e.currentTarget.style.color = "#07588f"; }}
											onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#d9d9d9"; e.currentTarget.style.color = "rgba(0,0,0,0.85)"; }}
										>
											Sort: {selectedOrder} ▼
										</AntButton>
									</Dropdown>
								</Col>
								<Col lg={3} md={3} xs={8} style={{ marginBottom: "10px", display: "flex", gap: "8px" }}>
									<AntButton
										style={{ background: "#07588f", color: "#fff", border: "none", flex: 1, borderRadius: "20px", height: "36px", transition: "all 0.3s ease" }}
										onMouseEnter={(e) => { e.currentTarget.style.background = "#0a6ebd"; e.currentTarget.style.transform = "translateY(-2px)"; e.currentTarget.style.boxShadow = "0 4px 12px rgba(7,88,143,0.3)"; }}
										onMouseLeave={(e) => { e.currentTarget.style.background = "#07588f"; e.currentTarget.style.transform = "translateY(0)"; e.currentTarget.style.boxShadow = "none"; }}
										onClick={() => filterFaqs()}
									>
										Search
									</AntButton>
									<AntButton
										style={{ flex: 1, borderRadius: "20px", height: "36px", transition: "all 0.3s ease" }}
										onMouseEnter={(e) => { e.currentTarget.style.borderColor = "#07588f"; e.currentTarget.style.color = "#07588f"; e.currentTarget.style.transform = "translateY(-2px)"; }}
										onMouseLeave={(e) => { e.currentTarget.style.borderColor = "#d9d9d9"; e.currentTarget.style.color = "rgba(0,0,0,0.85)"; e.currentTarget.style.transform = "translateY(0)"; }}
										onClick={clearSearch}
									>
										Clear
									</AntButton>
								</Col>
							</Row>
						</Container>

						<div className='inner_wrap'>

							{/* <h2>Frequently Asked Questions?</h2> */}
							<div className='acc_wrap'>
								{isLoading ?
									<Box sx={{ my: '5rem' }}>
										<LinearProgress color="success" />
									</Box>
									:
									<Collapse style={{
										bacgroundColor: "red"
									}} accordion
										activeKey={activeKey} onChange={setActiveKey}>
										{paginatedFaqs?.map((val, index) => {

											return (
												<Panel
													header={
													// 	val.question.length > 80 ? (
													// 	<Tooltip title={val.question}>
													// 		<span style={{color: activeKey?.includes(index.toString()) ? "white" : "black"}}>{val.question.slice(0, 80)}...</span>
													// 	</Tooltip>
													// ) : (
														<span>{val.question}</span>
														// <span style={{color: activeKey?.includes(index.toString()) ? "white" : "black"}}>{val.question}</span>
													// )
												}
													key={index}
													// style={{ backgroundColor: activeKey?.includes(index.toString()) ? "#16b2b0" : "white" }}
												>
													{/* <p>{val.answer}</p> */}
													<p><td dangerouslySetInnerHTML={{ __html: val.answer }} /></p>
													{/* <p><td style={{color: activeKey?.includes(index.toString()) ? "white" : "black"}} dangerouslySetInnerHTML={{ __html: val.answer }} /></p> */}
												</Panel>
											);
										})}
									</Collapse>
								}
							</div>
						</div>
					</div>
					<Pagination
						total={faqs.length}
						current={currentPage}
						hideOnSinglePage
						pageSize={pageSize}
						onChange={(page) => setCurrentPage(page)} />
				</section>


			</div>
		</>
	);
};

export default Faqs;
